import React from 'react';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';

import Box from '@mui/material/Box';

class FormField extends React.Component {

  render () {
    const { classes, className, children, ...others } = this.props;
    return (
        <Box className={clsx(classes.root, className)} {...others}>
          { children }
        </Box>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
  },
});

export default withStyles(styles, { withTheme: true })(FormField);
